import http, { type HttpResponse } from "lib/http";

const url = "/api/threat-defence/msgraphsettings";
const accountUrl = (accountId: number) => `/api/accounts/${accountId}/ms-graph-settings`;

export interface IAccountMsGraphSettingsService {
  msGraphSettingsExist: (accountId: number) => Promise<boolean>;
  saveMsGraphSettings: (tenantId: string, accountId: number) => Promise<HttpResponse<void>>;
  getAuthorizeUrl: () => Promise<string>;
  deleteMsGraphSettings: (accountId: number) => Promise<HttpResponse<void>>;
}

const instance: IAccountMsGraphSettingsService = {
  getAuthorizeUrl: async () => {
    const r = await http.get<{ redirectLocation: string }>(`${url}/authorize`);
    return r.isSuccess ? r.data.redirectLocation : "";
  },

  msGraphSettingsExist: async (accountId: number) => {
    const r = await http.head(accountUrl(accountId));
    return r.isSuccess;
  },

  saveMsGraphSettings: (tenantId: string, accountId: number): Promise<HttpResponse<void>> =>
    http.post(accountUrl(accountId), { tenantId }),

  deleteMsGraphSettings: (accountId: number): Promise<HttpResponse<void>> => http.delete(accountUrl(accountId)),
};

export default instance;
